import React from 'react';
import { Virtual } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
import { Swiper, SwiperSlide } from 'swiper/react';

import { OVERLAYS_URL } from '../../../Settings';
import {
    availableAmenities, availableBeds,
} from '../../Game/GamePlayerInfo';
import { getTextureUrl } from '../../TwoD/Common/TextureTools';

import '../../TwoD/Components/Controls/Actions/action-scroller.css';
import './ResearchChoice.css';

const OVERLAY_RESEARCH = OVERLAYS_URL
    + 'ResearchOverlay-1080x210.png';

// ResearchChoice — verbatim port of ResearchController's render
// (the amenities + beds pools). TWO anchor divs in sequence, each
// with its own `<img className="swiper-overlay">` over a Swiper.
// Clicks dispatch through onAmenityClick / onBedClick passed by
// ResearchActionWindow; the Swiper.onClick payload's clickedIndex
// indexes into the underlying pool array.
//
// Purely presentational. The highlight-storage-event dispatch
// lifecycle lives in ResearchActionWindow (state owner), NOT here.
export function ResearchChoice({
    gameData, onAmenityClick, onBedClick,
}) {
    const amenities = (gameData && gameData.amenity_pool)
        ? availableAmenities(gameData) : [];
    const beds = (gameData && gameData.bed_pool)
        ? availableBeds(gameData) : [];

    const buyAmenity = (swiper) => {
        if (typeof onAmenityClick !== 'function') return;
        const amenityId = amenities[swiper.clickedIndex];
        onAmenityClick(amenityId);
    };

    const buyBed = (swiper) => {
        if (typeof onBedClick !== 'function') return;
        const bedId = beds[swiper.clickedIndex];
        onBedClick(bedId);
    };

    return (
        <div className={'research-choice'}
             data-testid={'research-choice'}>
            <div className={'research-choice-anchor'}
                 data-testid={'research-choice-amenities'}>
                <img src={OVERLAY_RESEARCH}
                     alt={'action'}
                     data-testid={'research-choice-overlay-amenities'}
                     className={'swiper-overlay'}/>
                <Swiper slidesPerView={6}
                        spaceBetween={0}
                        modules={[Virtual]}
                        onClick={buyAmenity}>
                    {amenities.map((textureId, index) => (
                        <SwiperSlide key={'gi-' + index}
                                     virtualIndex={index}>
                            <div data-testid={
                                    'research-choice-amenity'}
                                 data-amenity-id={textureId}
                                 data-pool-index={index}
                                 data-tname={textureId || undefined}>
                                <img src={getTextureUrl(textureId)}
                                     alt={'research'}/>
                            </div>
                        </SwiperSlide>
                    ))}
                </Swiper>
            </div>
            <div className={'research-choice-anchor'}
                 data-testid={'research-choice-beds'}>
                <img src={OVERLAY_RESEARCH}
                     alt={'action'}
                     data-testid={'research-choice-overlay-beds'}
                     className={'swiper-overlay'}/>
                <Swiper slidesPerView={6}
                        spaceBetween={0}
                        modules={[Virtual]}
                        onClick={buyBed}>
                    {beds.map((textureId, index) => (
                        <SwiperSlide key={'gi-' + index}
                                     virtualIndex={index}>
                            <div data-testid={
                                    'research-choice-bed'}
                                 data-bed-id={textureId}
                                 data-pool-index={index}
                                 data-tname={textureId || undefined}>
                                <img src={getTextureUrl(textureId)}
                                     alt={'research'}/>
                            </div>
                        </SwiperSlide>
                    ))}
                </Swiper>
            </div>
        </div>
    );
}

export default ResearchChoice;
